import { BusinessForm } from "./Forms/BusinessForm";
import { IncomeForm } from "./Forms/IncomeForm";
import { InitialFinancingForm } from "./Forms/InitialFinancingForm";
import { StaffForm } from "./Forms/StaffForm";
import { OperatingExpensesForm } from "./Forms/OperatingExpensesForm";
import { CreditForm } from "./Forms/CreditForm";
import { MarketingForm } from "../../../components/CommonBusinessPlanForms/MarketingForm";
import { SwotForm } from "../../../components/CommonBusinessPlanForms/SwotForm";
import { RiskForm } from "../../../components/CommonBusinessPlanForms/RiskForm";
import { ProfileForm } from "../../../components/CommonBusinessPlanForms/ProfileForm";
export const PARAM_GROUPS = [
    {
        id: 1,
        title: "Настройки для расчетов",
        description: "Настройте исходные данные для расчета бизнес-плана. По умолчанию установлены усредненные значения",
        modes: [
            "Business",
            "Income",
            "InitialFinancing",
            "Staff",
            "OperatingExpenses",
            "Credit",
        ],
    },
    {
        id: 2,
        title: "Настройки для документа",
        description: "Заполните разделы для формирования печатной версии бизнес-плана",
        modes: [
            "Marketing",
            "Swot",
            "Risk",
            "Profile",
        ],
    },
];
export const FORM_PARAMS = [
    {
        title: "Параметры бизнеса",
        icon: "settings",
        mode: "Business",
        component: BusinessForm,
        keys: [
            "start_date",
            "form",
            "taxation",
            "square",
            "square_main",
            "rent_cost",
            "rent_month",
            "service_cost",
            "service_month",
        ],
    },
    {
        title: "Доходы",
        icon: "money",
        mode: "Income",
        component: IncomeForm,
        keys: [
            "use_count",
            "avg_check",
            "day_count",
            "power_schedule",
        ],
    },
    {
        title: "Первоначальное финансирование",
        icon: "rouble",
        mode: "InitialFinancing",
        component: InitialFinancingForm,
        keys: [
            "reg_cost",
            "reg_schedule",
            "docs_cost",
            "docs_schedule",
            "deposit_cost",
            "deposit_schedule",
            "repair_cost",
            "repair_schedule",
            "product_cost",
            "product_schedule",
            "soft_cost",
            "soft_schedule",
            "adv_cost",
            "adv_schedule",
            "recruit_cost",
            "recruit_schedule",
            "other_cost",
            "other_schedule",
            "equipment_list",
        ],
    },
    {
        title: "Штатное расписание",
        subtitle: "Укажите в таблице количество и размеры ставок для разных должностей наемных работников. " +
            "Вы можете исключать из расчетов различные категории наемного персонала, " +
            "для этого переместите курсор в начало строки и кликнув на меню (три точки) удалите соответствующую строку таблицы. " +
            "Чтобы вернуться к рекомендуемым параметрам позиций и ставок персонала, нажмите «Сбросить к базовым» слева внизу экрана",
        icon: "tutoring",
        mode: "Staff",
        component: StaffForm,
        keys: ["personal_list"],
    },
    {
        title: "Операционные расходы",
        icon: "calculator",
        mode: "OperatingExpenses",
        component: OperatingExpensesForm,
        keys: [
            "material_proc",
            "marketing_proc",
            "production_proc",
            "office_cost",
        ],
    },
    {
        title: "Заемные средства",
        icon: "man-with-case",
        mode: "Credit",
        component: CreditForm,
        keys: [
            "credit_flag",
            "credit_time",
            "credit_proc",
            "credit_value",
            "credit_month",
            "credit_bank",
            "credit_other",
            "credit_comment",
        ],
    },
    {
        title: "Маркетинговая стратегия и план",
        icon: "marketing",
        mode: "Marketing",
        component: MarketingForm,
        keys: [
            "location_fl_flag",
            "location_tc_flag",
            "location_comment",
            "segment_portrait",
            "segment_profit",
            "segment_target",
            "segment_time",
            "difference_list",
            "strategy_list",
            "assortment1_list",
            "assortment2_list",
            "product_list",
            "channel_list",
        ],
    },
    {
        title: "SWOT-анализ",
        icon: "compare",
        mode: "Swot",
        component: SwotForm,
        keys: [
            "swot",
        ],
    },
    {
        title: "Оценка рисков",
        icon: "hot",
        mode: "Risk",
        component: RiskForm,
        keys: [
            "risk_list",
        ],
    },
    {
        title: "Сведения о предпринимателе",
        hideTitle: true,
        icon: "document",
        mode: "Profile",
        resetLabel: "Сбросить",
        component: ProfileForm,
        keys: [
            "user_add_flag",
            "user_address",
            "user_company",
            "user_contact_mail",
            "user_contact_phone",
            "user_fio",
            "user_inn",
            "user_mail",
            "user_ogrn",
            "user_okved",
            "user_phone",
            "user_reg_date",
            "user_site",
            "user_tg",
            "user_vk",
        ],
    },
];
export const CHART_NAMES = {
    0: "Выручка, млн. руб.",
    1: "Прибыль, млн. руб.",
};
